import React from 'react';
import { Box, Typography, Button, Alert } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

// Catches render-time crashes so users see a recovery screen instead of a
// blank white window. Data in SQLite is unaffected by renderer crashes.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Unexpected application error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.hash = '#/';
    window.location.reload();
  };

  render() {
    if (this.state.error) {
      return (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight="100vh"
          gap={3}
          p={4}
        >
          <Typography variant="h5" fontWeight="bold">
            Something went wrong
          </Typography>
          <Alert severity="error" sx={{ maxWidth: 600 }}>
            {String(this.state.error?.message || this.state.error)}
          </Alert>
          <Typography color="text.secondary" textAlign="center" maxWidth={480}>
            Your data is safe. Reload the application to continue — if this
            keeps happening, export a backup from Settings and contact support.
          </Typography>
          <Button variant="contained" startIcon={<RefreshIcon />} onClick={this.handleReload}>
            Reload Application
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
